import React, { useEffect } from "react";
import { useContext } from "react";
import { GamePopupContext } from "../../component/Context/GamePopupContext";
import { motion } from "framer-motion";
import arrow from "../../Assets/img/arrow-sm.png";
import { useAuthContext } from "../../AuthContext";

const RoomCard = (props) => {
  const { dispatchPopUp } = useContext(GamePopupContext);
  const {setErrorState} = useAuthContext();
  useEffect(() => {
    return () => {
      dispatchPopUp({ type: "close", name: props?.name });
    };
  }, []);

  const AuthValidator = () => {
    if (props?.title === "Free Game Play") {
      props.play();
    } else {
      if (props?.isAuthenticated) {
        dispatchPopUp({ type: "open", name: props?.name });
      } else {
        props?.paymentPopUp(true);
      }
    }
  };
  return (
    <motion.div
      className={`col-lg-2 games`}
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      <span className={`${props?.glow ? "animate-glory overflow-hidden animate-span" : ""}`}></span>
      <h2>{props?.title}</h2>
      {props.subtitle ? (
        <button
          onClick={
            () => AuthValidator()
            /*  props.title === "Practice Game"
              ? props.play
              : () => dispatchPopUp({ type: "open", name: props?.name }) */
          }
        >
          {props?.subtitle}

          <img src={arrow} alt="arrow" />
        </button>
      ) : (
        ""
      )}
      <div className="container-images-play-friends">
        <img src={props?.img} alt="" />
        <img className="absImageBlured" src={props?.img} alt="" />
      </div>
    </motion.div>
  );
};

export default RoomCard;
